module.exports = __webpack_public_path__ + "static/finalTasks-b218cb1a0a2287fe52ab5ffb8c6ed305.png";